import {c as createCommonjsModule} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {d as defaultTheme_1, e as esm} from "./defaultTheme-ca6a0b43.js";
var styled_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.slotShouldForwardProp = exports.rootShouldForwardProp = exports.default = void 0;
  var _defaultTheme = interopRequireDefault(defaultTheme_1);
  const rootShouldForwardProp = (prop) => (0, esm.shouldForwardProp)(prop) && prop !== "classes";
  exports.rootShouldForwardProp = rootShouldForwardProp;
  const slotShouldForwardProp = esm.shouldForwardProp;
  exports.slotShouldForwardProp = slotShouldForwardProp;
  const styled = (0, esm.createStyled)({
    defaultTheme: _defaultTheme.default,
    rootShouldForwardProp
  });
  var _default = styled;
  exports.default = _default;
});
var useThemeProps_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = useThemeProps;
  var _defaultTheme = interopRequireDefault(defaultTheme_1);
  function useThemeProps({
    props,
    name
  }) {
    return (0, esm.useThemeProps)({
      props,
      name,
      defaultTheme: _defaultTheme.default
    });
  }
});
export {styled_1 as s, useThemeProps_1 as u};
